const state = {
  errorPage: null
}

// Getters
const getters = {
  // UserData
  errorPage (state) {
    return state.errorPage
  }
}

// Mutations
const mutations = {
  'SET_ERROR_PAGE' (state, errorPage) {
    state.errorPage = errorPage
  }
}

export default {
  state,
  getters,
  mutations
}
